<template>
  <v-dialog
    v-model="show"
    width="40vw"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    scrollable
    persistent
  >
    <v-card height="auto" elevation="5" class="rounded-lg" min-height="200">
      <v-card-title class="text-h5 lighten-2">
        <v-row no-gutters>
          <v-col cols="12">
            <span>
              <span> Nueva entrega </span>

              {{ orderToUpdate.deliveryOrders.length + 1 }}
              - OP {{ orderToUpdate.serial }}
            </span>
          </v-col>
          <v-col cols="12">
            <span class="text-subtitle-1">
              {{ orderToUpdate.client }}
            </span>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-form ref="loteForm" lazy-validation>
            <v-row no-gutters>
              <v-col cols="12">
                <v-switch
                  v-model="isUrgent"
                  label="Pedido de urgencia"
                ></v-switch>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  label="Fecha entrega"
                  dense
                  outlined
                  clearable
                  type="date"
                  v-model="deliveryDate"
                ></v-text-field>
              </v-col>
              <v-col cols="12" align="end">
                <v-btn
                  color="primary"
                  rounded
                  @click="(showNewProduct = true), (showAdvice = false)"
                >
                  <v-icon> mdi-plus </v-icon>
                  Añadir producto
                </v-btn>
              </v-col>
              <v-col cols="12" align="start" v-if="showAdvice">
                <span class="decrease">No hay prodcutos en OP</span>
              </v-col>
              <v-col cols="12" class="mt-5">
                <v-card elevation="10" class="rounded-lg">
                  <v-card-text>
                    <v-data-table
                      fixed-header
                      height="300px"
                      :headers="headers"
                      :items="products"
                      :items-per-page="10"
                      no-data-text="No hay productos"
                      loading-text="Cargando productos..."
                    >
                      <template #[`item.type`]="{ item }">
                        <span v-if="item.type">
                          {{ item.type.name }} {{ item.type.value == 'NA'? `(${item.folio})` : undefined }}
                        </span>
                        <span v-else>-</span>
                      </template>
                      <template #[`item.line`]="{ item }">
                        <span v-if="item.moType && item.line">
                          <div v-if="item.moType == 'bacteria'">
                            <div
                              v-if="item.name == 'Streptomyces griseoviridis'"
                            >
                              AS
                            </div>
                            <div v-else>B{{ item.line }}</div>
                          </div>
                          <div v-if="item.moType == 'fungi'">
                            H{{ item.line }}
                          </div>
                        </span>
                        <span v-else>
                          <span v-if="item.line">
                            {{ item.line }}
                          </span>
                          <span v-else>-</span>
                        </span>
                      </template>
                      <template #[`item.presentation`]="{ item }">
                        <span>{{ item.presentation.name }}</span>
                      </template>
                      <template #[`item.order`]="{ item }">
                        <v-row>
                          <v-col>
                            <v-icon color="red" @click="removeProduct(item)">
                              mdi-delete
                            </v-icon>
                          </v-col>
                          <v-col>
                            <v-icon
                              color="primary"
                              @click="updateProduct(item)"
                            >
                              mdi-pencil
                            </v-icon>
                          </v-col>
                        </v-row>
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-container>
          <v-row>
            <v-col>
              <v-btn
                color="red"
                block
                @click="closeModal"
                dark
                :disabled="isLoading"
                >Cancelar</v-btn
              >
            </v-col>
            <v-col>
              <v-btn
                color="primary"
                block
                @click="confirmation()"
                :loading="isLoading"
              >
                <span v-if="deliveryToUpdate"> Actualizar entrega </span>
                <span v-else> Agregar entrega </span>
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
    <ProductModal
      v-model="showNewProduct"
      v-if="showNewProduct"
      @addProduct="addProduct"
    />
  </v-dialog>
</template>

<script>
//vuex
import { mapActions, mapState, mapMutations } from "vuex";
//axios
import axios from "axios";
//validations
import { requiredValidation, requiredMultiple } from "@/helpers/validations.js";
// date library
import dayjs from "dayjs";
//components
import ProductModal from "@/components/dashboard/production-orders/modals/ProductModal.vue";
export default {
  components: {
    ProductModal,
  },
  data: () => ({
    headers: [
      {
        text: "Nombre",
        align: "start",
        value: "name",
        sortable: false,
      },
      {
        text: "Tipo",
        align: "center",
        value: "type",
        sortable: false,
      },
      {
        text: "Linea",
        align: "center",
        value: "line",
        sortable: false,
      },
      {
        text: "Presentación",
        align: "center",
        value: "presentation",
        sortable: false,
      },
      {
        text: "Piezas",
        align: "center",
        value: "qty",
        sortable: false,
      },
      { text: "Acciones", align: "center", value: "order", sortable: false },
    ],
    products: [],
    isLoading: false,
    user: JSON.parse(localStorage.getItem("user")),
    showNewProduct: false,
    showAdvice: false,
    deliveryDate: null,
    client: null,
    isUrgent: false,
  }),
  props: {
    value: Boolean,
  },
  computed: {
    ...mapState("order", ["orderToUpdate", "deliveryToUpdate"]),
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  created() {
    this.client = this.orderToUpdate.client;
  },
  methods: {
    ...mapActions("order", ["addDeliveryOrder", "updateDeliveryOrder"]),
    ...mapMutations("order", [
      "SET_PRODUCT_SELECTED",
      "SET_ORDER_TO_UPDATE",
      "SET_DELIVERY_OP_TO_UPDATE",
    ]),
    closeModal() {
      this.SET_DELIVERY_OP_TO_UPDATE(null)
      this.show = false;
    },
    async confirmation() {
      //emit fetch table
      if (this.$refs.loteForm.validate() && this.products.length > 0) {
        try {
          this.showAdvice = false;
          this.isLoading = true;
          let payload = {
            orderId: this.orderToUpdate._id,
            products: this.products,
            user: this.user,
            deliveryDate: this.deliveryDate,
            isUrgent: this.isUrgent,
          };

          let response = await this.addDeliveryOrder(payload);
          if (response) {
            // this.SET_ORDER_TO_UPDATE(response.orderUpdated);
            this.$emit("update");
          } else {
            this.$swal({
              icon: "error",
              title: `Algo salio mal al crear OP`,
              showConfirmButton: false,
              timer: 2000,
            });
          }
        } catch (e) {
          console.log(e);
          this.$swal({
            icon: "error",
            title: `Algo salio mal al crear OP`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
        this.isLoading = false;
      } else {
        if (this.products.length == 0) {
          this.showAdvice = true;
        }
      }
    },
    validation(name) {
      return requiredValidation(name);
    },
    validationMultiple(name) {
      return requiredMultiple(name);
    },
    addProduct(value) {
      let index = this.products.length;

      this.products.push({
        id: index,
        name: value.name,
        identification: value.identification,
        productType: value.productType,
        qty: value.qty,
        type: value.type,
        line: value.line,
        presentation: value.presentation,
        moType: value.moType,
        folio: value.folio,
        _id: value._id,
      });

      this.showNewProduct = false;
    },
    removeProduct(item) {
      let index = this.products.indexOf(item);
      this.products.splice(index, 1);
    },
    updateProduct(item) {
      this.SET_PRODUCT_SELECTED(item);
      this.showNewProduct = true;
    },
  },
  watch: {
    // showNewProduct(value) {
    //   if (!value) {
    //     this.SET_PRODUCT_SELECTED(null);
    //   }
    // },
  },
};
</script>

<style scoped>
.decrease {
  background-color: red;
  color: white;
}
</style>
